import * as R from 'ramda'
import PropTypes from 'prop-types'
import { isFunction } from 'lodash'
import { usePlan } from 'commons/useSubscription'
import { isPlanFreeTierByPlanId } from 'commons/plan'

const ERROR_FREE_TIER_TEAM_MEMBER_SIGN_IN =
  'ERROR_FREE_TIER_TEAM_MEMBER_SIGN_IN'
const ERROR_RESTRICTED_PLACE_TEAM_MEMBER_SIGN_IN =
  'ERROR_RESTRICTED_PLACE_TEAM_MEMBER_SIGN_IN'

export const isFreeTierPlaceTeamMemberSignInError = R.propEq(
  'type',
  ERROR_FREE_TIER_TEAM_MEMBER_SIGN_IN,
)
export const isRestrictedPlaceTeamMemberSignInError = R.propEq(
  'type',
  ERROR_RESTRICTED_PLACE_TEAM_MEMBER_SIGN_IN,
)

export const rejectOnFreeTierButNotRootAdmin = ({ user, place, ...rest }) => {
  const isRootAdmin = R.equals(R.prop('id', user), R.prop('creatorId', place))
  const isPaidPlan = R.compose(
    getIsPaidPlan,
    R.path(['activeSubscription', 'plan']),
  )(place)
  return isRootAdmin || isPaidPlan
    ? Promise.resolve({ user, place, ...rest })
    : Promise.reject({
        type: ERROR_FREE_TIER_TEAM_MEMBER_SIGN_IN,
        id: 'error.403.freeTierTeamMemberNotAllowed',
        user,
      })
}

export const rejectOnRestrictedPlanButNotRootAdmin = ({
  user,
  place,
  ...rest
}) => {
  const isRootAdmin = R.equals(R.prop('id', user), R.prop('creatorId', place))
  const isRestrictedPlan = R.prop('isRestricted', place)
  return isRootAdmin || !isRestrictedPlan
    ? Promise.resolve({ user, place, ...rest })
    : Promise.reject({
        type: ERROR_FREE_TIER_TEAM_MEMBER_SIGN_IN,
        id: 'permission.restricted.alert.text',
        user,
      })
}

export const teamMemberSignInErrorMessage = R.curry((formatMessage, error) =>
  formatMessage({ id: error.id }, { name: R.prop('firstName', error.user) }),
)

const getIsPaidPlan = R.compose(
  R.ifElse(R.isNil, R.always(false), R.complement(isPlanFreeTierByPlanId)),
  R.prop('id'),
)

export const useIsPaidPlan = () => {
  const plan = usePlan()
  return getIsPaidPlan(plan)
}

export const PaidPlanAccess = ({ children, freePlanComponent = null }) => {
  const isPaidPlan = useIsPaidPlan()
  if (isFunction(children)) {
    return children(isPaidPlan)
  }
  return isPaidPlan ? children : freePlanComponent
}

PaidPlanAccess.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  freePlanComponent: PropTypes.element,
}

export const useIsRouteGrantedByPaidPlan = (matched) => {
  const isPaidPlanRequired = R.pathOr(
    false,
    ['route', 'paidPlanRequired'],
    matched,
  )
  const isPaidPlan = useIsPaidPlan()
  return isPaidPlanRequired === isPaidPlan
}
